import React, { useEffect } from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import Modal from '~components/atoms/Modal';
import BranchesDetailsForm from '../BranchesDetailsForm';
import ActionButton from '~components/atoms/ActionButton';

import { BranchStatusEnum, ModuleEnum, PermissionsEnum } from '~utils/enums';

import * as Styles from './_branchesDeleteBranchModal.module.scss';
import { TEditBranchDetailsReduxParams } from '~types/feat/branch';

const BranchesDeleteBranchModal = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(state => state.branch.modals.deleteBranchModalIsOpen);
    // const isEditing = useAppSelector(state => state.branch.modals.isEditing);
    const isLoading = useAppSelector(state => state.branch.loadings.editBranchDetails);
    const editBranchDetailsError = useAppSelector(state => state.branch.errors.editBranchDetails);
    const branchDetails = useAppSelector(state => state.branch.selectedBranch);

    const userAccess = useAppSelector(state => state.auth.userDetails.access);
    const hasEditAccess = !!userAccess.find(item => item.permission === PermissionsEnum.Edit)?.modules.find(module => module === ModuleEnum.BranchManagement);

    if (!branchDetails || !hasEditAccess) return null;

    const handleModalOnClose = () => {
        dispatch(combinedActions.branchSetDeleteBranchModalIsOpen(false));
    };

    const handleOnSubmit = (data: TEditBranchDetailsReduxParams) => dispatch(combinedActions.branchEditBranchDetailsAttempt({ ...data, status: BranchStatusEnum.Deleted }));

    return (
        <Modal
            title='Delete Branch'
            isOpen={isOpen}
            onClose={handleModalOnClose}
        >
            <div className={Styles.subcontainer}>
                <BranchesDetailsForm
                    submitButtonLabel='Delete'
                    actionButtonIsLoading={isLoading}
                    actionButtonClassName={Styles['action-button']}
                    actionButtonIsDisabled={true}
                    onSubmit={handleOnSubmit}
                    inputIsDisabled={true}
                    error={editBranchDetailsError}
                    isEditing={true}
                    initialBranchDetails={branchDetails}
                />
            </div>
        </Modal>
    );
};

export default BranchesDeleteBranchModal;
